import { render, staticRenderFns } from "./exchangeRate.vue?vue&type=template&id=7048c5d2&scoped=true&"
import script from "./exchangeRate.vue?vue&type=script&lang=js&"
export * from "./exchangeRate.vue?vue&type=script&lang=js&"
import style0 from "./exchangeRate.vue?vue&type=style&index=0&id=7048c5d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7048c5d2",
  null
  
)

export default component.exports